<template>
    <div class="map_wap">
        <nav-bar
            title="附近农户"
            fixed
            @click-left="back"
          >
        </nav-bar>
        <div class="map_dis flex_start">
            <div class="f_w">距离：</div>
            <div class="dis_box">
                <div class="flex_wrap">
                    <div class="dian_box" @click="onSelectDis(item)" v-for="(item,index) in disList" :key="item.id">
                        <div class="dian_img" :class="{a_none:index==disList.length-1}"></div>
                        <div class="dis">{{item.name}}</div>
                    </div>
                </div>
             </div>
        </div>
         <el-amap
                style="height:70%"
                ref="map"
                class="amap-box"
                :vid="'shop-detail2'"
                :amap-manager="amapManager"
                :plugin="plugin"
                :events="events"
                :zoom="10">
                <div v-if="markers.length">
                    <el-amap-marker v-for="(marker,i) in markers" :position="marker.position" :events="marker.events" :key="i">
                    </el-amap-marker>
                </div>
        </el-amap>
        <div class="list_box" :class="{full: fullFlag}" ref="bar" :style="{top: y}">
            <div class="bar_box" @touchstart="gtouchstart" @touchmove="gtouchmove" @touchend="gtouchend">
                <div  class="bar" ></div>
                <div class="f_title">
                    <div class="f_name">农户姓名</div>
                    <div class="f_n">购买总数(袋)</div>
                    <div class="f_a">地址</div>
                </div>
            </div>
            <div class="scroll_box" v-if="farmer.length">
                <div class="f_item" @click="onSelect(item, true)" v-for="item in farmer" :key="item.id+(Math.random())">
                    <div class="f_name one_line">{{item.real_name}}</div>
                    <div class="f_n one_line">{{item.buy_amount||0}}</div>
                    <div class="f_a one_line">{{item.address}}</div>
                </div>
            </div>
            <div v-else class="no_info">附近暂无农户</div>
        </div>
    </div>
</template>
<script>
import VueAMap from 'vue-amap'
import tools from '@/mixins/tools'
import getLocation from '@/mixins/getLocation'
import api from '@/utils/api'
import NavBar from '@/components/navBar'
// import Vue from 'vue'
// import wx from 'weixin-jsapi'
import { Popup } from 'vant'
const amapManager = new VueAMap.AMapManager()
export default {
    name: 'Famer',
    mixins: [tools, getLocation],
    components: {
        [Popup.name]: Popup,
        NavBar
    },
    data: () => {
        return {
            amapManager,
            events: {
                init: (o) => {}
            },
            fullFlag: false,
            plugin: [],
            markers: [],
            farmer: [],
            height: '50%',
            show: true,
            disList: [
                {
                    name: '5公里',
                    id: 5
                },
                {
                    name: '10公里',
                    id: 10
                },
                {
                    name: '20公里',
                    id: 20
                },
                {
                    name: '50公里',
                    id: 50
                },
                {
                    name: '100公里',
                    id: 100
                }
            ],
            y: '70%'
        }
    },
    mounted() {
        this.currentPos = {}
        this.current = null
        this.loading()
        // this.getLocation().then(res => {
        //     console.log(res)
        //     this.currentPos = { lat: res.curLat, lng: res.curLng }
        //     this.current = new AMap.LngLat(parseFloat(res.curLat), parseFloat(res.curLng))
        //     this.getFarmerList({ lat: res.curLat, lng: res.curLng, dis: 5 })
        // })
        this.starY = window.screen.height * 0.7
        this.starYEnd = window.screen.height * 0.7
        this.disY = window.screen.height * 0.7
    },
    methods: {
        gtouchstart(e) {
            this.fullFlag = false
            e.preventDefault()// 阻止触摸时页面的滚动，缩放
            this.disY = e.touches[0].clientY - this.$refs.bar.offsetTop - 20
            // 手指按下时的坐标
            this.starY = e.touches[0].clientY
            console.log(this.starY)
        },
        gtouchmove(e) {
            if ((e.touches[0].clientY - this.disY) > window.screen.height * 0.7) return
            this.y = ((e.touches[0].clientY - this.disY) / window.screen.height) * 100 + '%'
            this.starYEnd = e.touches[0].clientY - this.starY
            var dis = parseInt(this.y) / 100
            console.log(dis)
        },
        gtouchend() {
            var dis = parseInt(this.y) / 100
            console.log(dis)
            this.fullFlag = true
            if (dis < 0.4) {
                this.y = 0
            } else {
                this.y = '70%'
            }
        },
        // 地图弹窗
        onSelect(item, flag) {
            var r = parseInt(Math.random() * 999)
            var content = `<div style="width:200px">
                                    <div style="color:#121212;font-size:14px">
                                        <p style="margin-bottom:8px">姓名：${item.real_name}</p>
                                        <p style="margin-bottom:8px">地址：${item.address}</p>
                                        <p style="margin-bottom:8px">购买总数(袋)：${item.buy_amount || 0}</p>
                                    </div>
                                    <div class="detail_link"  style="display:flex;justify-content: space-between;align-items: center;">
                                        <a id="detail${r}" href="javascript:;" >详情</a>
                                        <a id="path${r}" href="https://uri.amap.com/navigation?from=${this.currentPos.lng},${this.currentPos.lat},startpoint&to=${item.longitude},${item.latitude},endpoint&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0" style="border-radius:23px;text-align:center;color:#fff;padding:3px 10px;background-color:#339DFA">导航到这里</a>
                                    </div>
                                </div>`
            this.createCom(item)
            var infowindow2 = new AMap.InfoWindow({
                content: content,
                asOrigin: false,
                asDestination: false,
                offset: new AMap.Pixel(0, -30)
            })
            infowindow2.on('open', () => {
                setTimeout(() => {
                    document.querySelector('#detail' + r).addEventListener('click', (e) => {
                        e.preventDefault()
                        this.$router.push(`/farmerdetail?id=${item.id}`)
                    }, false)
                    // map-navigation?endLng=116.483038&endLat=39.990633&toName=北京门店
                    document.querySelector('#path' + r).addEventListener('click', (e) => {
                        e.preventDefault()
                        this.$router.push(`/map-navigation?endLng=${item.longitude}&endLat=${item.latitude}&toName=当前农户`)
                    }, false)
                }, 500)
            })
            infowindow2.open(this.$refs.map.$$getInstance(), [parseFloat(item.longitude), parseFloat(item.latitude)])
            if (flag) {
                this.$refs.map.$$getInstance().setCenter([parseFloat(item.longitude), parseFloat(item.latitude)])
            }
        },
        // 获取农户坐标
        getFarmerList(data) {
            this.farmer = []
            this.markers = []
            api.getFarmerList(data).then(res => {
                this.hideLoading()
                if (res.data && res.data.length) {
                    res.data.forEach(item => {
                        console.log(parseFloat(item.longitude), parseFloat(item.latitude))
                        var dis = new AMap.LngLat(parseFloat(item.longitude), parseFloat(item.latitude))
                        // dis =AMap.GeometryUtil.distanceOfLine([dis, this.current])
                        // var len = dis.distance(this.current) / 10000
                        var len = AMap.GeometryUtil.distanceOfLine([dis, this.current]) / 1000
                        console.log(len)
                        this.farmer.push(item)
                        if (len < data.dis) {
                            this.farmer.push(item)
                        }
                        // return { ...item }
                    })
                    if (this.farmer.length === 0) {
                        return
                    }
                    var markers = this.farmer.map(item => {
                        return {
                            id: item.id,
                            open: true,
                            position: [parseFloat(item.longitude), parseFloat(item.latitude)],
                            visible: true,
                            draggable: false,
                            clickable: true,
                            events: {
                                click: () => {
                                    console.log(item)
                                    if (Object.keys(this.currentPos).length === 0) {
                                        // this.getLocation().then(res => {
                                        //     console.log(res)
                                        //     this.currentPos = { lat: res.curLat, lng: res.curLng }
                                        // })
                                        return
                                    }
                                    this.onSelect(item, false)
                                }
                            }
                        }
                    })
                    this.markers = markers
                    setTimeout(() => {
                        // 设置地图缩进范围 setCenter
                        this.$refs.map.$$getInstance().setFitView()
                    }, 400)
                    console.log(this.markers)
                }
            })
        },
        // 距离选择
        onSelectDis(item) {
            this.loading()
            this.getFarmerList({ lat: this.currentPos.lat, lng: this.currentPos.lng, dis: item.id })
        },
        createCom(item) {
            // var content = `<div style="width:200px">
            //                         <div style="color:#121212;font-size:14px">
            //                             <p style="margin-bottom:8px">姓名：${item.real_name}</p>
            //                             <p style="margin-bottom:8px">地址：${item.address}</p>
            //                             <p style="margin-bottom:8px">购买总数(袋)：${item.buy_amount || 0}</p>
            //                         </div>
            //                         <div  style="display:flex;justify-content: space-between;align-items: center;">
            //                             <a href="/farmerdetail?id=${item.id}">详情</a>
            //                             <a href="https://uri.amap.com/navigation?from=${this.currentPos.lng},${this.currentPos.lat},startpoint&to=${item.longitude},${item.latitude},endpoint&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0" style="border-radius:23px;text-align:center;color:#fff;padding:3px 10px;background-color:#339DFA">导航到这里</a>
            //                         </div>
            //                     </div>`
            // var v = new Vue({
            //     template: content
            // }).$mount()
            // console.log(content)
        }
    }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
